import { render, staticRenderFns } from "./auth-layout.component.vue?vue&type=template&id=00c36f4c&scoped=true"
import script from "./auth-layout.component.ts?vue&type=script&lang=ts&external"
export * from "./auth-layout.component.ts?vue&type=script&lang=ts&external"
import style0 from "./auth-layout.component.vue?vue&type=style&index=0&id=00c36f4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c36f4c",
  null
  
)

export default component.exports